const _ = require('../_');

function getNextCode(previousCode) {
  if (!previousCode) {
    return '1';
  }

  const codeRanges = [
    { startChar: 'A', startCharCode: 'A'.charCodeAt(0), endChar: 'Z', endCharCode: 'Z'.charCodeAt(0) },
    { startChar: 'a', startCharCode: 'a'.charCodeAt(0), endChar: 'z', endCharCode: 'z'.charCodeAt(0) },
    { startChar: '0', startCharCode: '0'.charCodeAt(0), endChar: '9', endCharCode: '9'.charCodeAt(0) },
  ];

  const charCode = previousCode.charCodeAt(previousCode.length - 1);
  const matchedRange = _.find(codeRanges, codeRange => codeRange.startCharCode <= charCode && charCode <= codeRange.endCharCode);
  if (matchedRange) {
    if (charCode === matchedRange.endCharCode) {
      return getNextCode(previousCode.substring(0, previousCode.length - 1)) + matchedRange.startChar;
    }
    return previousCode.substring(0, previousCode.length - 1) + String.fromCharCode(charCode + 1);
  }
  return getNextCode(previousCode.substring(0, previousCode.length - 1)) + previousCode.substring(previousCode.length - 1);
}

// NOTE: getNextCode above handles non-numeric codes but the following
// methods only handle numeric codes and treat trailing 0's the same as
// if they weren't included
function getLastFullCodeComponent(fullCode) { // also passed: , ignoreTrailingZeros = false
  const tokens = fullCode ? fullCode.split('.') : [];
  if (tokens.length >= 1) {
    return tokens[tokens.length - 1];
  }
  return '';
}

function compareFullCode(a, b) {
  const aTokens = (a || '').split('.');
  const bTokens = (b || '').split('.');
  for (let i = 0; i < Math.max(aTokens.length, bTokens.length); i++) {
    if (i >= aTokens.length) {
      return -1;
    }
    if (i >= bTokens.length) {
      return 1;
    }
    const aTokenValue = Number(aTokens[i]);
    const bTokenValue = Number(bTokens[i]);
    if (aTokenValue !== bTokenValue) {
      return aTokenValue - bTokenValue;
    }
  }
  return 0;
}

function getFullCodeParents(fullCode) {
  const tokens = fullCode ? fullCode.split('.') : [];
  const lastTokenIndex = tokens.length - 1;
  if (lastTokenIndex <= 0) {
    return [];
  }
  return _.range(lastTokenIndex).map((i) => {
    const parentTokens = tokens.slice(0, i + 1);
    return parentTokens.join('.');
  });
}

function getFullCodeComponentCount(fullCode) {
  const tokens = fullCode ? fullCode.split('.') : [];
  return tokens.length;
}

module.exports = {
  getNextCode,
  getLastFullCodeComponent,
  compareFullCode,
  getFullCodeParents,
  getFullCodeComponentCount,
};
